module.exports = __webpack_public_path__ + "img/user.b43c132d.svg";